export const actionKey = '@@APP';

//# sourceMappingURL=constants.js.map